import markerUri from '../../../dist/images/marker.svg';
import clusterUri from '../../../dist/images/marker-cluster.svg';

export default function initializeFindMap() {
    document.querySelectorAll('.block-find-place').forEach(function (block) {
        new FindMap(block);
    });
}

class FindMap {
    constructor(block) {
        this.block = block;
        this.mapMarkers = [];
        this.leafletMarkers = [];
        this.markerClusters = [];
        this.fitBounds = 0;

        this.urlParams = new URL(document.location).searchParams;
        this.urlParamCounty = this.urlParams.get('county') ? this.urlParams.get('county') : 'all';

        this.initialize();


    }

    async initialize() {

        // Importowanie Leaflet
        const leafletModule = await import('leaflet');
        const L = leafletModule.default;
        window.L = L;

        await import('leaflet.markercluster');

        // Importowanie React
        const React = await import('react');
        const { createRoot } = await import('react-dom/client');
        window.React = React;


        this.initDOMElements();
        this.initializeFpForm();
        this.initLeafletMap();

        this.root = createRoot(this.container);
    }

    initDOMElements() {
        this.mapElement = document.getElementById('fp-map');
        this.voivodeshipSelect = this.block.querySelector('.select-voivodeship select');
        this.countySelectContainers = this.block.querySelectorAll('.select-county');
        this.countySelects = this.block.querySelectorAll('.select-county select');
        this.countyValueInput = this.block.querySelector('#fp-county-value');
        this.submitButton = this.block.querySelector('#fp-submit');
        this.container = this.block.querySelector('.fp-points');
    }

    initializeFpForm() {


        // Akcja po zmianie województwa
        this.voivodeshipSelect.addEventListener('change', () => {
            const voivodeship = this.voivodeshipSelect.value;
            this.countySelectContainers.forEach((select) => {
                if (select.dataset.voivodeship === voivodeship) {
                    select.classList.remove('d-none');
                } else {
                    select.classList.add('d-none');
                    select.querySelector('option[value="all"]').selected = true;
                }
            });

            this.countyValueInput.value = 'all';
            this.countyValueInput.dispatchEvent(new Event('change'));
        });

        // Sprawdzanie czy pole countyValueInput się zmieniło
        this.countyValueInput.addEventListener('change', () => {
            const county = this.countyValueInput.value;
            if (county === 'all') {
                this.submitButton.disabled = true;
                this.submitButton.classList.add('button--disabled');
            } else {
                this.submitButton.disabled = false;
                this.submitButton.classList.remove('button--disabled');
            }
        });

        if (this.urlParamCounty !== 'all') {
            // Znajdujemy select z powiatem
            this.countySelects.forEach((countySelect) => {
                countySelect.querySelectorAll('option').forEach((option) => {
                    if (option.value === this.urlParamCounty) {
                        const voivodeship = countySelect.closest('.select-county').dataset.voivodeship;

                        this.voivodeshipSelect.querySelector(`option[value="${voivodeship}"]`).selected = true;
                        this.voivodeshipSelect.dispatchEvent(new Event('change'));
                        option.selected = true;
                        this.countyValueInput.value = option.value;
                        this.countyValueInput.dispatchEvent(new Event('change'));
                    }
                });
            });
        }

        // Akcja po zmianie powiatu
        this.countySelects.forEach((countySelect) => {
            countySelect.addEventListener('change', () => {
                this.countyValueInput.value = countySelect.value;
                this.countyValueInput.dispatchEvent(new Event('change'));
                this.submitButton.click();
            });
        });
    }

    filterPoints(map) {
        const countyValue = this.block.querySelector('#fp-county-value');
        const container = this.block.querySelector('.fp-points');

        this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();

            const loader = this.block.querySelector('.block-find-place__loader');
            loader.style.display = 'flex';
            container.style.display = 'none';

            for (let i = 0; i < this.markerClusters.length; i++) {
                map.removeLayer(this.markerClusters[i]);
            }
            this.leafletMarkers = [];
            this.mapMarkers = [];

            const county = countyValue.value;

            this.loadAjaxStores(county).then((data) => {
                const points = data.results;

                for (let i = 0; i < points.length; i++) {
                    const posLat = points[i].fields.pos_lat;
                    const posLon = points[i].fields.pos_lon;
                    this.addMapMarker(parseFloat(posLat), parseFloat(posLon), points[i].id);
                }

                this.showMapMarkers(map);

                this.addPoints(points);
                loader.style.display = 'none';
                container.style.display = 'flex';
            });
        });
    }

    addPoints(points) {
        // HTML wygenerowany z JSX
        this.root.render(
            <>
                {points.length === 0 && (
                    <div className="block-find-place__point">
                        <p className="block-find-place__point__noresult">{this.container.dataset.noresults}</p>
                    </div>
                )}

                {points.length > 0 && (
                    <>
                        {points.map((point, index) => (
                            <div className="block-find-place__point" key={index}>
                                <h3 className="block-find-place__point-title is-style-h4">{point.title}</h3>
                                <div
                                    className="block-find-place__point-desc"
                                    dangerouslySetInnerHTML={{ __html: point.fields.desc }}
                                />
                                {point.fields.link?.length > 0 && (
                                    <div className="wp-block-buttons">
                                        <div className="wp-block-button is-style-outline-mini">
                                            <a
                                                className="wp-block-button__link wp-element-button block-find-place__point-link"
                                                href={point.fields.link}
                                            >
                                                Zobacz szczegóły o oddziale
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </>
                )}
            </>
        );
    }

    initLeafletMap() {
        const container = this.block.querySelector('.fp-points');
        const loader = this.block.querySelector('.block-find-place__loader');

        if (this.mapElement) {
            const map = L.map(this.mapElement, {
                scrollWheelZoom: false,
                zoomControl: false,
            }).setView([52.10006685381763, 18.714205129598994], 6);

            L.control.zoom({
                position: 'bottomright',
            }).addTo(map);

            // Dodaj warstwę kafelków Open Street Map
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18,
                attribution: '&copy; OpenStreetMap contributors',
            }).addTo(map);

            map.on('zoomend', () => {
                this.mapZoomChanged(map);
            });

            this.loadAjaxStores(this.urlParamCounty).then((data) => {
                const points = data.results;

                if (points.length > 0) {
                    for (let i = 0; i < points.length; i++) {
                        const posLat = points[i].fields.pos_lat;
                        const posLon = points[i].fields.pos_lon;

                        this.addMapMarker(parseFloat(posLat), parseFloat(posLon), points[i].id);
                    }

                    this.showMapMarkers(map);
                }

                this.addPoints(points);
                loader.style.display = 'none';
                container.style.display = 'flex';
            });
            this.filterPoints(map);
        }
    }

    addMapMarker(lat, lng, fpID = 0) {
        this.mapMarkers.push({ lat, lng, fpID });
    }

    showMapMarkers(map) {
        if (this.mapMarkers.length) {
            const bounds = new L.LatLngBounds();

            const markers = L.markerClusterGroup({
                iconCreateFunction: (cluster) => {
                    const markerHtmlStyles = `
                        background: center / contain no-repeat url('${clusterUri}');
                        width:40px;
                        height:40px;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        color:#fff;
                        `;
                    return L.divIcon({
                        html: `<div style="${markerHtmlStyles}">${cluster.getChildCount()}</div>`,
                        className: 'marker-cluster',
                        iconSize: L.point(20, 20),
                        style: {
                            color: '#aaa',
                        }
                    });
                },
            });

            for (let i = 0; i < this.mapMarkers.length; i++) {
                const marker = L.marker([this.mapMarkers[i].lat, this.mapMarkers[i].lng], {
                    icon: L.icon({
                        iconUrl: markerUri,
                        iconSize: [19, 26],
                        iconAnchor: [10, 26],
                        popupAnchor: [1, -13],
                        shadowSize: [30, 30],
                    }),
                });

                // marker.on('click', () => this.onMarkerClick(this.mapMarkers[i].fpID));

                markers.addLayer(marker);
                bounds.extend(marker.getLatLng());
                this.leafletMarkers.push(marker);
            }

            map.addLayer(markers);
            this.markerClusters.push(markers);
            map.fitBounds(bounds, { maxZoom: this.mapMarkers.length > 1 ? 6 : 9 });
            this.fitBounds = 1;

            if (!this.mapMarkers.length) {
                map.setView([51.0650101, 21.0645886], 13);
            }
        }
    }

    onMarkerClick(fpID) {
        const container = this.block.querySelector('.fp-points');

        if (window.innerWidth < 768) {
            container.scrollIntoView();
        }

        const loader = this.block.querySelector('.block-find-place__loader');
        loader.style.display = 'flex';
        container.style.display = 'none';

        this.loadAjaxSingleStore(fpID).then((data) => {
            const points = data.results;

            this.addPoints(points);
            loader.style.display = 'none';
            container.style.display = 'flex';
        });
    }

    mapZoomChanged(map) {
        if (map.getZoom() > 14 && this.fitBounds === 1) {
            map.setZoom(14);
            this.fitBounds = 0;
        }
    }

    async loadAjaxStores(county = 'all') {
        const params = {
            county: county,
        };

        const url = `${window.location.origin}/wp-json/f/v1/points/?${new URLSearchParams(params)}`;

        this.setBrowserURL(county);

        const request = new Request(url, {
            method: 'GET',
        });

        const response = await fetch(request);

        return response.json();
    }

    async loadAjaxSingleStore(fpID) {
        const params = {
            id: fpID,
        };

        const url = `${window.location.origin}/wp-json/f/v1/points/?${new URLSearchParams(params)}`;

        const request = new Request(url, {
            method: 'GET',
        });

        const response = await fetch(request);

        return response.json();
    }

    setBrowserURL(county = 'all') {
        const currentUrl = window.location.origin + window.location.pathname;

        const urlParams = {};

        if (county !== 'all' && county !== '') {
            urlParams.county = county;
        }

        let urlPart = `?${new URLSearchParams(urlParams)}`;
        if (county === 'all' || county === '') {
            urlPart = '';
        }

        window.history.replaceState(null, null, currentUrl + urlPart);
    }
}